'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { Table } from '@/components/common/Table';
import * as Compact from '@/components/common/Table/CompactTable/Table';
interface VaultV2ExposureCategoryRowProps {
  label: string;
  columnCount: number;
}
export function VaultV2ExposureCategoryRow(t0) {
  const $ = _c(6);
  const {
    label,
    columnCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      lineHeight: "normal"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span className="text-3xs text-secondary-foreground" style={t1}>{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== columnCount || $[4] !== t2) {
    t3 = <Table.Tr><Compact.Td colSpan={columnCount} className="border-border border-y-[0.5px] [&_.td-content]:h-[28px]">{t2}</Compact.Td></Table.Tr>;
    $[3] = columnCount;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export default memo(VaultV2ExposureCategoryRow);